import styled from 'styled-components'

import { helpers } from 'styles'

export const Content = styled.div`
	border-top: 1px solid ${helpers.color.separator};

	&:empty {
		border-top: none;
	}
`
